
import React from "react";
import Slider from "react-slick";
import "../../../styles/slick.css"; 
import "../../../styles/slick-theme.css";
import CompassItem from "../../molecule/CompassItem";
import { useRef } from "react";
import { Compass 
    } from "../../atoms/Carousel";
import { useEffect } from "react";
import "./NavCarousel.css";
import { useState } from "react";

export default function NavCarousel(props){
   const {contentArray,carouselClickHandler} = props;
   const sliderRef = useRef();
   const [currentCenter, setcurrentCenter] = useState(props?.initialSlide? props?.initialSlide : 0);
   useEffect(() => {
    if(props?.currentMobilestationID>-1){
        sliderRef.current.slickGoTo(props.currentMobilestationID);
        carouselClickHandler(contentArray && contentArray[props.currentMobilestationID], props.currentMobilestationID);
        setcurrentCenter(props.currentMobilestationID)
    }
   }, [props?.currentMobilestationID]);
    const settings = {
        className: props?.community?"map-navigation community-home-nav":"map-navigation community-home-nav",
        infinite:false,
        speed: 500,
        slidesPerRow: 1,
        initialSlide: 0,
        prevArrow: props?.community?"":"",
        nextArrow: props?.community?"":"",
        afterChange: props?.mapView ? (index)=> itemClickHandler(contentArray[index],index) : "",
        centerMode: true,
        slidesToShow: props?.community? 6:"",
      };
    //   useEffect(()=>{
    //     sliderRef.current.slickGoTo(0);
    //   },[sliderRef])
    useEffect(()=>{
        window.matchMedia("(orientation: portrait)").addEventListener("change", (e) => {
            // window.location.reload();
            e.matches;
            if(sliderRef?.current&&contentArray&&contentArray.length>0){
                sliderRef.current.slickGoTo(0);
                carouselClickHandler(contentArray[0], 0)
            }    
      });
      },[contentArray])

     const itemClickHandler = (item,i) =>{
        sliderRef.current.slickGoTo(i);
        setcurrentCenter(i)
        carouselClickHandler(item, i)
     } 
     
    return(
        <Compass mapView={props.mapView} isCelebrationChild={props?.isCelebrationChild} community={props?.community} isDayTime={props?.isDayTime}>
            <div className="first-circle">
                <Slider {...settings} ref={sliderRef}>
                        {contentArray && contentArray?.map((obj, index)=>{
                            return <CompassItem key={index} pos={index} currentCenter={currentCenter} item={obj} itemClickHandler={itemClickHandler}/>
                        })}
                </Slider>
            </div>
        </Compass>

    )
}

